import script from "./ServiceSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceSection.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceSection.vue?vue&type=style&index=0&id=5f58d48c&lang=scss"

const __exports__ = script;

export default __exports__